module.exports = __webpack_public_path__ + "static/img/banner5x.5d39efac.png";